export default "__VITE_ASSET__8SNiDDzK__"